<template>
  <div class="reports__panel--yearmonth">
    <b-field :label="label">
      <dropdown
        :sourceList="options"
        :keyPropertyName="(o) => o.value"
        :displayPropertyName="(o) => o.label"
        @selectionChanged="selectionChanged"
      >
      </dropdown>
    </b-field>
  </div>
</template>

<script>
import Dropdown from "@/components/common/Dropdown.vue";
import moment from "moment";

export default {
  name: "reports-panel-yearmonth",
  components: { Dropdown },
  props: {
    offsetMonth: {
      type: Number,
      default: 0,
    },
    fromYear: {
      type: Number,
      default: 0,
    },
    selected: {
      type: Object,
    },
    firstRun: {},
    label: {
      type: String,
      default: "Måned, År",
    },
  },
  data: () => ({
    options: [],
    selectedObject: Object,
  }),
  mounted() {
    this.options = this.buildOptions();
  },
  methods: {
    buildOptions() {
      const options = [];
      let date = moment();
      options.push({
        value: {
          month: moment(date).month(),
          year: moment(date).year(),
        },
        label: moment(date).format("MMMM, YYYY"),
        isSelected: true,
      });

      // Add future months if offsetMonth is greater than 0
      if (this.offsetMonth > 0) {
        for (let i = 1; i < this.offsetMonth; i++) {
          date = moment(date).add(1, "months");
          options.push({
            value: {
              month: moment(date).month(),
              year: moment(date).year(),
            },
            label: moment(date).format("MMMM, YYYY"),
            isSelected: false,
          });
        }
      }

      // Reset date to current month
      date = moment();
      const currentYear = Number(moment().year());
      const fromYear = this.fromYear ? Number(this.fromYear) : 0;

      // Add past months up to three years earlier
      let totalMonths = 12 + moment(date).month() + 1;

      if (fromYear > 2020 && currentYear > fromYear) {
        // 2025 - 2023 = (2 - 1) * 12 - 1 = 11
        const month = ((currentYear - fromYear) - 1) * 12 - 1;
        totalMonths += month;
      }

      for (let i = 1; i <= totalMonths; i++) {
        date = moment(date).subtract(1, "months");
        options.push({
          value: {
            month: moment(date).month(),
            year: moment(date).year(),
          },
          label: moment(date).format("MMMM, YYYY"),
          isSelected: false,
          backgroundColor: this.offsetMonth > 0 ? "yellow" : "inherit",
        });
      }
      return options;
    },
    selectionChanged(value) {
      this.$emit("year", value.year);
      this.$emit("month", value.month);
    },
  },
  computed: {},
  watch: {
    selected(newValue) {
      if (this.options !== undefined) {
        const index = this.options.indexOf(
          this.options.find((o) => o.value.month === newValue.month)
        );
        this.options[index].isSelected = true;
      }
    },
  },
};
</script>

<style lang="scss">
.reports__panel--yearmonth {
  .ctrl-button {
    padding-left: 10px !important;
  }
}
</style>
